var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card', { 'card--scroll': _vm.scrollCard, 'card--mobHide': _vm.hideMobile, 'card--full': _vm.fullCard }, _vm.extraClass],style:(_vm.extraStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }